

<template>
  <div >
    <modal
      name="petition-workflow-configuration"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
      <!-- <span class="im_overlay" @click="$modal.hide('petition-workflow-configuration'); configPopup=false;"></span> -->
      <div class="v-modal">
        <div class="popup-header ddd">
          <h2 class="popup-title">
            {{
              editpetitionTemplateConfigaration
                ? "Update Case Configuration "
                : "Case Configuration"
            }}
          </h2>
          <span
            @click="
              $modal.hide('petition-workflow-configuration');
              configPopup = false;
              formSubmited = false;
              $emit('hideMe');
            "
            ><em class="material-icons">close</em></span>
        </div>

        <div class="form-container">
            <form>
          <div class="vx-row">
            <div class="vx-col mb-6 mt-1"  v-if=" [1].indexOf(getUserRoleId)>-1">
              <div class="custom-radio custom-radio_btns" >  
                           
                <vs-radio class="mr-6"  v-model="wiseSelection" vs-value="true" @change="updateSelection()">Global</vs-radio>
                <vs-radio v-model="wiseSelection" vs-value="false"  @change="updateSelection()">Customer</vs-radio>
              </div> 
            </div>
            <div class="vx-col w-full">
              <div class="form_group mb_10">              
              <div class="con-select">
              <label class="form_label mb-0">Case Type<em>*</em></label>
              <multiselect
                name="petitionType"
                v-model="selectedPetitionType"
                :multiple="false"
                :show-labels="false"
                :ref="'petitionTypes'"
                track-by="_id"
                label="name"
                @input="changedPetitionType;" 
                data-vv-as="Case Type"
                v-validate="'required'"
                :disabled="editpetitionTemplateConfigaration"  
                 placeholder="Select Case Type"
                :options="petitionTypesList"
                :searchable="true"
                :allow-empty="false"
              >
              
              </multiselect>
               <span  class="text-danger text-sm"  v-show="errors.has('petitionType')" >{{ errors.first("petitionType") }}</span>
              </div>
              </div>
            </div>
          </div>
        
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="form_group mb_10">               
            
              <div class="con-select">
                <label class="form_label mb-0">Case Subtype</label>
              <multiselect
                name="petitionsubTypes"
                v-model="selectedPetitionSubType"
                :multiple="false"
                :disabled="petitionTypeId==null || editpetitionTemplateConfigaration || petitionSubTypesList.length<=0"
                :show-labels="false"
                :ref="'petitionTypes'"
                track-by="_id"
                label="name"
                data-vv-as="Case Type"
                 placeholder="Select Case Subtype"
                :options="petitionSubTypesList"
                  @input="changedPetitionSubType;formerrors.msg=''"
                :searchable="true"
                :allow-empty="false"
                
              >
              </multiselect>
              </div>
              </div>
            </div>
          </div>
          <div class="vx-row" v-if=" [1].indexOf(getUserRoleId)>-1 && !isGlobal">
            <div class="vx-col w-full">
              <div class="form_group mb_10">            
              <div class="con-select">
               <label class="form_label mb-0">Customers<em>*</em></label>
               <multiselect
                      v-model="selectedTenant"
                      :options="tenantsList"
                      :multiple="true" :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Customers"
                      label="name"
                      track-by="_id"
                      :preselect-first="false"
                      @input="changedTenant"
                      data-vv-as="Customers"
                      v-validate="'required'"
                      name="customer"
                    
                    > 
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Customer(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                    <span  class="text-danger text-sm"  v-show="errors.has('customer')" >{{ errors.first("customer") }}</span>
              



            </div>
              </div>
            </div>
          </div>
          <div class="vx-row" v-if="[1].indexOf(getUserRoleId)>-1">
            <div class="vx-col w-full">
              <div class="form_group mb_10">            
              <div class="con-select">
              <label class="form_label mb-0">Questionnaire Template<em v-if="[1].indexOf(getUserRoleId)>-1">*</em></label>
              <multiselect
                name="questionnaireTemplate"
                v-model="selectedQuestionnaireTemplate"
                :multiple="false"
                :show-labels="false"
                :ref="'questionnaire-templates'"
                track-by="_id"
                label="name"
                data-vv-as="Questionnaire Template"
                v-validate="([1].indexOf(getUserRoleId))>-1?'required':''"
                :options="questionnaireTemplatsList"
                :searchable="true"
                :allow-empty="false"
                placeholder="Select Questionnaire Template"
                 @input="formerrors.msg=''"
                 :disabled="editpetitionTemplateConfigaration"
              >
              </multiselect>
              <span class="text-danger text-sm" v-show="errors.has('questionnaireTemplate')">{{ errors.first("questionnaireTemplate") }}</span>
            </div>
              </div>
            </div>
          </div>
            <div class="vx-row">
            <div class="vx-col w-full">
              <div class="form_group mb_10">             
              <div class="con-select">
             <label class="form_label mb-0">Forms And Letters<em v-if="[3].indexOf(getUserRoleId)>-1">*</em></label>
              <multiselect
                name="PetitionConfiguration"
                v-model="selectedFormsAndlatters"
                :multiple="true" :hideSelected="true"
                 :close-on-select="false"
                :show-labels="false"
                @input="formerrors.msg=''"
                :ref="'formsLetters'"
                track-by="_id"
                label="name"
                :options="formsAndLettersList"
                :searchable="true"
                :allow-empty="false"
                placeholder="Select Forms Letters"
                 data-vv-as="Forms Letters"
                v-validate="([3].indexOf(getUserRoleId))>-1?'required':''"
              >
              <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Forms and Letter(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
              </multiselect>
              <span class="text-danger text-sm" v-show="errors.has('PetitionConfiguration')">{{ errors.first("PetitionConfiguration") }}</span>
            </div>
              </div>
            </div>
          </div>

          

          <div class="text-danger text-sm formerrors"  v-show="formerrors.msg" @click="formerrors.msg=''">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
          </div>

            </form>
        </div>
        <div class="popup-footer">
          <vs-button
            class="cancel"
            @click="
              $modal.hide('petition-workflow-configuration');
              configPopup = false;
              formSubmited = false;
              selectedTenant =[]
            "
            >Cancel</vs-button
          >
<!---selectedQuestionnaireTemplate == null || selectedPetitionType ==null || formSubmited--->
          <vs-button 
            class="save"
            :disabled="formSubmited"
            type="filled"
            @click="petitionConfigAction()"
          >
            {{ editpetitionTemplateConfigaration ? "Update" : "Save" }}
          </vs-button>
        </div>
      </div>
    </modal>

    <vs-popup style="z-index:999999; !important" class="holamundo main-popup"  title="Configuration is already linked with Case(s)" :active.sync="updateOrCreateFormsLattersPopup">
      <div class="form-container">
        
        <div class="vx-row">
          <div class="vx-col w-full">
          <p>{{selectionMessage}}</p>
            
          </div>
          
        </div>

         <div v-show="errorMessage">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ errorMessage}}</vs-alert>
          </div>
       
      </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled" @click="updateOrCreateFormsLattersPopup=false">Cancel </vs-button>
        <template >   
            <vs-button color="success"  :disabled="formSubmited"  class="save w-auto" type="filled" @click="petitionConfigAction('update')">Update Existing</vs-button>
             <vs-button color="success" :disabled="formSubmited"  class="save w-auto" type="filled" @click="petitionConfigAction('create')">Create New</vs-button>
        </template>
        
      </div>
  </vs-popup>
  </div>
</template>


<script>
import _ from "lodash";
import moment from "moment";

export default {
  watch:{
    selectedPetitionType:function(val){
      if(!this.editpetitionTemplateConfigaration){
        this.changedPetitionType(val);
      }
      

    }
  },
  computed: {
    validateForm() {
      if (this.newform.name && this.newform.name.trim() != "") {
        return false;
      } else {
        return true;
      }
    },
  },
  components: {},

  data: () => ({
    wiseSelection:'true',
    isGlobal:true,
    formsAndLettersList:[],
    formSubmited: false,
    callFromSerch: false,
    selectedQuestionnaireTemplate: null,
    selectedFormsAndlatters:[],
    questionnaireTemplatsList: [],
    detailsPopup: false,
    selectedWorkFlow: null,
    configPopup: false,
    workFlowList: [],
    tempworkFlowList: [],
    petitionWorkFlowConfigDetails: [],

    selected_createdDateRange: ["", ""],
    autoApply: "",
    value: [],
    all_formTypes: [
      { name: "Form", id: "Form" },
      { name: "Letter", id: "Letter" },
    ],

    selectedItem: null,
    selectedStatus: 2,
    actionText: "Do you want to Delete?",
    formerrors: {
      msg: "",
    },
    date: null,
    approveConformpopUp: false,

    newform: {
      name: "",
      type: "",
      document: null,
      attachments: [],
      today: moment().format("YYYY-MM-DD"),
    },
    list: [],
    addPopup: false,
    NewPetition: false,

    searchtxt: "",
    query: [],
    country_code: 231,
    all_statusids: [],
    selected_statusids: [],
    final_selected_statusids: [],
    filter_roleIds: [],
    final_filter_roleIds: [1, 2, 3, 4, 5, 8, 9, 10, 11],

    seleted_states: [],
    final_selected_states: [],
    locations: [],
    // locationIds
    final_selected_typesids: [],
    selected_typeids: [],

    date_range: [],
    page: 1,
    perpage: 25,
    totalpages: 0,

    switch2: true,
    users_status: {},
    edit: false,
    sortKeys: {},
    sortKey: {},
    details: null,
    editworkFlowConfigaration: false,
    workflowConfigId: "",
    editpetitionTemplateConfigaration: false,
    showPetitionAlert: false,
    tenantsList:[],
    selectedTenant:[],
    selectedPetitionType:null,
    selectedPetitionSubType:null,
    petitionSubTypesList:[],
    petitionTypesList:[],
    petitionTypeId:null,

    updateOrCreateFormsLattersPopup:false,
      selectionMessage:false,
      fromFromsAndLatters:false,

  }),
  methods: {
    resetForm(){

      this.selectedPetitionType =null;
      this.selectedPetitionSubType = null;
      this.selectedQuestionnaireTemplate =null;
      this.selectedFormsAndlatters =[];
      this.selectedTenant = [];
      this.$validator.reset();
      this.getQuestionnaireTemplatsList();
    },
    changedTenant(item){
      this.formerrors.msg='';
     
      this.getQuestionnaireTemplatsList();
    },
     getpetitionConfigDetails(item){
      //petition-config/details
      this.selectedItem = item;
     
     
      if(this.checkProperty(this.selectedItem, "_id")  ){
        let postData ={"petitionConfigId":this.selectedItem['_id']};
       this.$store
            .dispatch("commonAction", {
              data: postData,
              path: "/petition-config/details",
            })
            .then((response) => {

               this.wiseSelection ='true';
        this.formSubmited =false;
this.isGlobal =true;
this.selectedPetitionType = null
this.selectedPetitionSubType=null;
this.selectedQuestionnaireTemplate =null;
this.selectedFormsAndlatters =[];

   if(this.checkProperty( response , 'tenantId' )){
     this.wiseSelection ='false';
     this.isGlobal =false;

   }

               
                
               
                if(response && _.has(response ,"typeDetails")){
                  this.selectedPetitionType = response['typeDetails'];
                  this.updatePetiotionType(response['typeDetails']);
                }
                if(response && _.has(response ,"subTypeDetails")){
                  this.selectedPetitionSubType = response['subTypeDetails'];
                  this.petitionSubTypeId  = this.selectedPetitionSubType['id'];
                  //alert(JSON.stringify(this.selectedPetitionSubType));
                }
              
                //questionnaireTplDetails
                 if(response && _.has(response ,"questionnaireTplDetails")){
                  this.selectedQuestionnaireTemplate = response['questionnaireTplDetails']
                }
               
              //newConfig.formsIds newConfig.letterIds Form Letter
              if(this.checkProperty(response ,'formAndLetterDetails') && response['formAndLetterDetails'].length>0 ){
                  
                _.forEach(response['formAndLetterDetails'] ,(doc)=>{
                  doc['name']  =   doc['name']+" ("+ doc['name']+")"
                  this.selectedFormsAndlatters.push(doc);
                  
                })
              }
              this.editpetitionTemplateConfigaration =true;
             Object.assign(this.formerrors, {
                msg: '',
              });
              this.$modal.show('petition-workflow-configuration');
             
             
             
            })
            .catch((error) => {
              //alert(JSON.stringify(error));
              Object.assign(this.formerrors, {
                msg: error,
              });
            });
    }
    },
    updateSelection(){
      this.selectedTenant=[];
      if(this.wiseSelection=='true'){
        this.isGlobal = true;

      }else{
        this.isGlobal = false;
      }
     
     this.resetForm();
    },
     getFormsAndLetters(){
         
             let postData ={'page':1 ,'perpage':1000000 ,getMasterData:true};
            this.$store.dispatch("getList" ,{data:postData,path:"/form-letter/list"})
            .then(response => {
              this.formsAndLettersList =[];

              _.forEach(response.list ,(item)=>{
                  item['name'] = item['name']+" ("+item['type']+")"
                  this.formsAndLettersList.push(item);
              });
            });

      },
      
      getenants() {
        let matcher = {};
        let query = {};
        query['page'] = 1;
        query['perpage'] = 10000;
         query['getMasterData'] = true;
        query['filters'] = matcher;
              

        this.$store
          .dispatch("getList",{data:query ,path:'/tenant/list'} )
          .then(response => {
            this.tenantsList = response.list;

          });
      },
      getPetitionTypes(){
        let payLoad ={matcher:{},page:1,perpage: 100000,category: "petition_types",};
        this.$store
          .dispatch("getMasterData",payLoad)
          .then(response => {
            this.petitionTypesList = response.list;
            this.selectedPetitionType = _.find(this.petitionTypesList, {"id":this.petitionTypeId});
            this.petitionSubTypesList = [];
          });
      },
      getPetitionSubTypes(){
         let payLoad ={matcher:{"petitionType":parseInt(this.petitionTypeId)}, page:1,perpage: 100000,
          category: "petition_sub_types", 
        };

        this.$store
          .dispatch("getMasterData",payLoad)
          .then(response => {
            this.petitionSubTypesList = response.list;
            this.selectedPetitionSubType = _.find(this.petitionSubTypesList, {"id":this.petitionSubTypeId});
            
          });
      },

      updatePetiotionType(item){
        
         this.selectedPetitionType = item,
        this.petitionTypeId =0;
       
        this.petitionSubTypesList = [];
        
        if(this.selectedPetitionType && _.has(this.selectedPetitionType,"id")){
          this.petitionTypeId =this.selectedPetitionType['id'];
          this.getPetitionSubTypes();
          
        }
      },
      
      changedPetitionType(item){
      
        this.selectedPetitionType = item,
        this.petitionTypeId =0;
       
        this.petitionSubTypesList = [];
        
          this.selectedPetitionSubType =null;
           this.petitionSubTypeId =0;
      
         
       
        if(this.selectedPetitionType && _.has(this.selectedPetitionType,"id")){
          this.petitionTypeId =this.selectedPetitionType['id'];
          this.getPetitionSubTypes();
          
        }

        /*
         petitionTypesList:[],
        
        ,
        selectedPetitionSubType:null,
        */

      },
      changedPetitionSubType(item){

        this.selectedPetitionSubType = item,
        this.petitionSubTypeId =0;
        if(this.selectedPetitionSubType && _.has(this.selectedPetitionSubType,"id")){
          this.petitionSubTypeId =this.selectedPetitionSubType['id'];
         
          
        }

      },
      getQuestionnaireTemplatsList() {
        let postData = {
          filters: {
            tenantIds:[]
          },
          getMasterData: true,
          getAll: true,
          page: 1,
          perpage: 25,
          sorting: { path: "createdOn", order: -1 },
        };

        if(this.selectedTenant && this.selectedTenant.length>0 && !this.isGlobal){
         
            postData['filters']['tenantIds'] =  this.selectedTenant.map((item)=>{
              return item['_id'];
            });
          }
              
        let self = this;

        this.$store
          .dispatch("commonAction", {
            data: postData,
            path: "/questionnaire/list",
          })
          .then((response) => {
            let tempList = [];
            let lst = response.list;
            _.forEach(lst, (item) => {
              item = Object.assign(item, { showMe: true });
              if((this.selectedTenant && this.selectedTenant.length>0 && !this.isGlobal)){
                 let name = item['name']
                if(_.has(item , "tenantDetails")){
                  name = item['name']+" ("+item['tenantDetails']['name']+")";
                  
                }else{
                   name = item['name']+" (Global)";

                }
                item = Object.assign(item, { name: name });

              }
              tempList.push(item);
            });
            this.questionnaireTemplatsList = tempList;
          })
          .catch((err) => {
            
          });
      },
      processPetitionTypes(showDetailpopUp = false) {
        this.detailsPopup = showDetailpopUp;
        //petitionWorkFlowConfigDetails
        // selectedWorkFlow:null,
        // workFlowList:[],
        // tempworkFlowList:[],
        let postData = {
          filters: {
            statusList: [true],
            createdByList: [],
            createdDateRange: [],
            petitionTypeList: [this.selectedItem["id"]],
          },

          page: 1, // Optional when 'getAll' send as 'true'
          perpage: 250000, // Optional when 'getAll' send as 'true'
          getAll: true, // Send as 'true' to get all list
        };
        this.$store
          .dispatch("getList", { data: postData, path: "/workflow/config-list" })
          .then((res) => {
            this.petitionWorkFlowConfigDetails = res.list;
            //this.tempworkFlowList = this.workFlowList;
            if (
              this.petitionWorkFlowConfigDetails.length > 0 &&
              this.workFlowList.length > 0
            ) {
              this.tempworkFlowList = [];
              _.forEach(this.workFlowList, (item) => {
                let findindex = _.findIndex(this.petitionWorkFlowConfigDetails, {
                  workflowId: item["_id"],
                });
                // alert(findindex + " === "+item.name)
                if (findindex <= -1) {
                  this.tempworkFlowList.push(item);
                }
              });
            } else {
              this.tempworkFlowList = this.workFlowList;
            }
          })
          .catch((err) => {
            //alert(err)
            
          });
      },
      openPetitionConfiguration(item) {
       
        this.selectedItem = item;
        this.tempworkFlowList = this.workFlowList;
        this.selectedWorkFlow = null;
        this.workFlowConfigDetails = [];
        this.configPopup = true;
        Object.assign(this.formerrors, {
                msg: '',
              });

        this.editworkFlowConfigaration = false;
        this.editpetitionTemplateConfigaration = false;
        this.workflowConfigId = "";
        this.processPetitionTypes();
        this.$modal.show("petition-workflow-configuration");
        this.formSubmited = false;
      },
      editWorkPetitionConfig(item, workflowConfigDetails) {
        this.selectedItem = item;
        this.tempworkFlowList = this.workFlowList;
        this.selectedQuestionnaireTemplate = null;
        this.workFlowConfigDetails = [];

        this.processPetitionTypes();
        //questionnaireTemplatsList
        
        if (
          this.checkProperty(this.selectedItem, "petitionConfigDetails") &&
          this.selectedItem["petitionConfigDetails"].length > 0
        ) {
          if (
            this.checkProperty(workflowConfigDetails, "questTplDetails") &&
            this.checkProperty(workflowConfigDetails, "questTplDetails")
          ) {
            this.selectedQuestionnaireTemplate = {
              _id: workflowConfigDetails["questTplDetails"]["_id"],
              name: workflowConfigDetails["questTplDetails"]["name"],
              showMe: true,
            };
            this.workflowConfigId = workflowConfigDetails["_id"];
          }
        }
        this.editpetitionTemplateConfigaration = true;
        this.configPopup = true;
        this.formSubmited = false;
        Object.assign(this.formerrors, {
                msg: '',
              });
        this.$modal.show("petition-workflow-configuration");
      },
      editWorkflowConfig(item, workflowConfigDetails) {
        this.selectedItem = item;
        this.tempworkFlowList = this.workFlowList;
        this.selectedWorkFlow = null;
        this.workFlowConfigDetails = [];

        this.processPetitionTypes();

        
        if (
          this.checkProperty(this.selectedItem, "workflowConfigDetails") &&
          this.selectedItem["workflowConfigDetails"].length > 0
        ) {
          if (
            this.checkProperty(workflowConfigDetails, "workflowId") &&
            this.checkProperty(workflowConfigDetails, "workflowName")
          ) {
            this.selectedWorkFlow = {
              _id: workflowConfigDetails["workflowId"],
              name: workflowConfigDetails["workflowName"],
              showMe: true,
            };
            this.workflowConfigId = workflowConfigDetails["_id"];
          }
        }
        this.editworkFlowConfigaration = true;
        this.configPopup = true;
        this.formSubmited = false;
        Object.assign(this.formerrors, {
                msg: '',
              });
        this.$modal.show("petition-workflow-configuration");

      },
      petitionConfigAction(updateAction='') {
         Object.assign(this.formerrors, {
                  msg: '',
                });
         this.$validator.validateAll().then(result => {

           //alert(result)
        
        if (result) {
          
          let postData = {
            typeId:this.selectedPetitionType? this.selectedPetitionType["id"]:null,
            subTypeId: this.selectedPetitionSubType? this.selectedPetitionSubType["id"]:null,
            //questionnaireTplId: this.selectedQuestionnaireTemplate["_id"],
            insertTo: "Global",
            formAndLetterIds: [],
            showPetitionAlert: false,
            tenantIds:[],
          }

          if(['create' ,'update'].indexOf(updateAction)>-1){
                postData =Object.assign(postData ,{"updateAction":updateAction})

              }else{
                this.updateOrCreateFormsLattersPopup =false;
                this.selectionMessage ='';
              }
         

          if([1].indexOf(this.getUserRoleId) >-1){
             if(!this.isGlobal){
              postData['insertTo'] ="Tenant"
            }
            if(this.selectedTenant.length>0){
             postData['tenantIds'] = _.map(this.selectedTenant, '_id');

            }
          

          }else{

              postData['insertTo'] ='Tenant';
              postData['tenantIds'] = [this.getTenantId]

          }

          if(this.selectedQuestionnaireTemplate && _.has(this.selectedQuestionnaireTemplate,'_id')){
            postData = Object.assign(postData, {questionnaireTplId: this.selectedQuestionnaireTemplate["_id"]})
          }

          if(this.selectedFormsAndlatters.length>0) {
            postData['formAndLetterIds'] = _.map(this.selectedFormsAndlatters, '_id');
          }
          //alert(postData['formAndLetterIds']);

          let actionPath = "/petition-config/create";
          if(this.editpetitionTemplateConfigaration){
            actionPath = "/petition-config/update"
            postData = Object.assign(postData , {'petitionConfigId':this.selectedItem['_id']})
          }
         // alert(JSON.stringify(postData));
          this.formSubmited = true;
          this.$store
            .dispatch("caseConfigUpdateOrCreate", { data: postData, path: actionPath })
            .then((res) => {
              this.formSubmited = false;
              
               this.updateOrCreateFormsLattersPopup =false;
                
                this.configPopup = false;
                this.$modal.hide("petition-workflow-configuration");
                this.editpetitionTemplateConfigaration = false;
                this.workflowConfigId = "";
                this.showToster({ message: res.message, isError: false });
                this.selectedQuestionnaireTemplate = null;
                this.workFlowConfigDetails = [];
                this.wiseSelection ='true'

                this.isGlobal =true;
                this.selectedPetitionType = null
                this.selectedPetitionSubType =null;
                this.selectedQuestionnaireTemplate =null;
                this.selectedFormsAndlatters =[];
                this.$emit("refreshList");
              
            })
            .catch((err) => {
               this.formSubmited = false;

              this.updateOrCreateFormsLattersPopup =false
                  //this.showToster({message:err ,isError:true});
                  if(this.checkProperty(err ,'code') =="LINKED_WITH_PETITION"){
                   this.updateOrCreateFormsLattersPopup =true;
                   this.selectionMessage = this.checkProperty(err ,'message');
                  

                  }else{
                   
                    Object.assign(this.formerrors, {  msg: err['message'],   });
                  }


             
               
            
            });
        }
         });
      },
      
     
     
     
      
      
      getList(callFromSerch = false) {
        this.callFromSerch = callFromSerch;
        let matcher = {
          title: this.searchtxt,
          statusIds: this.final_selected_statusids,
          typeIds: this.final_selected_typesids,
          createdDateRange: [],
        };
        if (
          this.selected_createdDateRange["startDate"] &&
          this.selected_createdDateRange["startDate"] != "" &&
          this.selected_createdDateRange["endDate"] != "" &&
          this.selected_createdDateRange["endDate"]
        ) {
          matcher["createdDateRange"] = [
            this.selected_createdDateRange["startDate"],
            this.selected_createdDateRange["endDate"],
          ];
        }

        let item = {
          matcher: {
            searchString: this.searchtxt,
            getWorkFlowConfig: true,
            // "petitionType":
          },
          page: this.page,
          perpage: this.perpage,
          category: "petition_types",
          sorting: this.sortKey,
        };

        this.$store.dispatch("getMasterData", item).then((response) => {
          this.list = response.list;
          this.totalpages = Math.ceil(response.totalCount / this.perpage);
          //alert(this.perpage);
        });
      },
     
      toggleModal(action=false){
         this.editpetitionTemplateConfigaration =false;
         Object.assign(this.formerrors, {
                  msg: '',
                });
        this.wiseSelection ='true';
        this.formSubmited =false;
this.isGlobal =true;
this.selectedPetitionType = null
this.selectedPetitionSubType=null;
this.selectedQuestionnaireTemplate =null;
this.selectedFormsAndlatters =[];
      // alert(action)
        if(action){
          this.$modal.show('petition-workflow-configuration');
        }else{
          this.$modal.hide('petition-workflow-configuration');
        }
        
      }
  },
  mounted() {
  this.getFormsAndLetters()
   this.getPetitionTypes();

    this.getenants();
    this.getQuestionnaireTemplatsList();
    this.selected_statusids = [];
    this.final_selected_statusids = [];
    this.seleted_states = [];
    this.final_selected_states = [];

    (this.sortKeys = {
      name: 1,
      type: 1,
      createdOn: -1,
      updatedOn: 1,
    }),
      (this.sortKey = { path: "createdOn", order: this.sortKeys["createdOn"] });

    this.sortKey = { path: "createdOn", order: -1 };

    if (
      localStorage.getItem("petitiin_sort_key") &&
      localStorage.getItem("petitiin_sort_value") &&
      localStorage.getItem("petitiin_sort_value") >= -1
    ) {
      this.sortKey = {};

      this.sortKey[localStorage.getItem("petitiin_sort_key")] = parseInt(
        localStorage.getItem("petitiin_sort_value")
      );
      this.sortKeys[localStorage.getItem("petitiin_sort_key")] =
        this.sortKey[localStorage.getItem("petitiin_sort_key")];

      //alert();
      
    }
    if (localStorage.getItem("formandLetter_perpage")) {
      this.perpage = parseInt(localStorage.getItem("formandLetter_perpage"));
    }

    this.getList();
  },
};
</script>
